export default __webpack_public_path__ + "static/media/face-4.d9a77836.svg";